// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL
});

export const setConfirmationModal = options => ({
    data: options,
    type: actions.SET_CLAIM_WEAR_PARTS_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/confirmation-modal.js